import React, { useCallback, useEffect, useState } from 'react';

import { sendSmsOtp } from 'features/authentication/actions';
import { CLEAN_UP_USER_PATH } from 'features/authentication/SignIn/constants';
import { ErrorTrackingProps } from 'features/authentication/SignIn/types';

import { toI18n } from 'util/i18n';

import CodeForm from '../CodeForm';

type Props = {
  phone: string;
} & ErrorTrackingProps;

const PhoneCodeVerify = ({ onError, phone }: Props) => {
  const [error, setError] = useState('');
  const [phoneId, setPhoneId] = useState('');

  const handleSuccess = useCallback(() => {
    window.location.href = CLEAN_UP_USER_PATH;
  }, []);

  const handleError = useCallback(
    // TODO: https://joinhomebase.atlassian.net/browse/FE-2199
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    error => {
      let errorMessage = toI18n('authentication.errors.initial_send_otp_error');
      if (error?.includes('MFA is enabled')) {
        errorMessage = toI18n(
          'authentication.errors.phone_verified_previously'
        );
      }

      setError(errorMessage);
      onError(errorMessage);
    },
    [onError]
  );

  useEffect(() => {
    sendSmsOtp({ phone })
      .then(({ phone_id }) => setPhoneId(phone_id))
      .catch(e => {
        e.response.json().then((body: { errors?: string }) => {
          handleError(body.errors);
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSendCode = useCallback(() => sendSmsOtp({ phone }), [phone]);

  return (
    <CodeForm
      initialAlertMessage={error}
      phoneNumber={phone}
      methodId={phoneId}
      onSetMethodId={setPhoneId}
      onSuccess={handleSuccess}
      onResendCode={handleSendCode}
      onError={onError}
    />
  );
};

export default PhoneCodeVerify;
